import { render, staticRenderFns } from "./photoList.vue?vue&type=template&id=3b8c65c7&scoped=true"
import script from "./photoList.vue?vue&type=script&lang=js"
export * from "./photoList.vue?vue&type=script&lang=js"
import style0 from "./photoList.vue?vue&type=style&index=0&id=3b8c65c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8c65c7",
  null
  
)

export default component.exports